import PropTypes from "prop-types"

import { cn } from "styles/utils"

const ProductDescription = ({ productName, size = "lg" }) => {
  return (
    <p
      className={cn(
        "mb-8 line-clamp-2 h-[calc(1.4em_*_2)] text-ellipsis",
        size === "lg"
          ? "desktop:line-clamp-1 desktop:h-[1.4em] body"
          : "body-sm"
      )}
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
  size: PropTypes.string,
}

export default ProductDescription
